import { createTableFilterSlice } from 'common/stores/redux/TableFilter';

const adminDraftFilterSlice = createTableFilterSlice('adminDraftFilter');

export const { add, addAdvanced, remove, removeAll } =
    adminDraftFilterSlice.actions;

export default adminDraftFilterSlice.reducer;
